var client = null;

var Util = function() {
    return {
        socketConnect: function(host, uid, uidSig, prevUid, prevUidSig, onEstablish, onBCStateChange, onDisconnect) {
            client = new SocketClient(io, host, uid, uidSig, prevUid, prevUidSig);
            if (onEstablish) {
                client.onEstablish = new Function(onEstablish);
            }
            if (onBCStateChange) {
                client.onBCStateChange = new Function(onBCStateChange);
            }
            if (onDisconnect) {
                client.onDisconnect = new Function(onDisconnect);
            }
            client.connect();
        },
        defaultFor: function(arg, val) {
            return typeof arg !== 'undefined' ? arg : val;
        },
        equalObjects: function(o1, o2) {
            return deepCompare(o1, o2);
        },
        copyObject: function(obj) {
            var object = $.extend(true, {}, obj);  // `true` for deep copy
            return object;
        },
        htmlspecialchars: function(string) {
            var entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&apos;'
            };
            return String(string).replace(/[&<>"']/g, function(s) {
                return entityMap[s];
            });
        },
        hasFocus: function() {
            if (typeof document.hasFocus === 'function') {
                return document.hasFocus();
            }
            return true;
        },
        now: function() {
            var now = Date.now() / 1000;
            return now;
        },
        nowISO: function() {
            // returns YYYY-MM-DD HH:II:SS
            var m = new Date();
            var dateString =
                m.getFullYear() + '-' +
                ('0' + (m.getMonth() + 1)).slice(-2) + '-' +
                ('0' + m.getDate()).slice(-2) + ' ' +
                ('0' + m.getHours()).slice(-2) + ':' +
                ('0' + m.getMinutes()).slice(-2) + ':' +
                ('0' + m.getSeconds()).slice(-2);
            return dateString;
        },
        randInt: function(min, max) {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        csrfAjax: function() {
            $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
                if (originalOptions.type !== 'POST' &&
                    originalOptions.type !== 'post') {
                    return;
                }
                var csrf = 'csrf_token=' + window.csrf['csrf_token'];
                if (originalOptions.data == undefined) {
                    options.data = csrf;
                } else if (typeof originalOptions.data === 'FormData' || originalOptions.data instanceof FormData) {
                    originalOptions.data.append('csrf_token', window.csrf['csrf_token']);
                } else if (typeof originalOptions.data === 'string' || originalOptions.data instanceof String) {
                    if (options.data.length > 0) {
                        options.data += '&' + csrf;
                    } else {
                        options.data = csrf;
                    }
                } else {
                    options.data = $.extend(originalOptions.data, window.csrf);
                    options.data = $.param(options.data);
                }
            });
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = Util;
}
